/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveAlertResponse
 */
export interface ActiveAlertResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    ruleId?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    machinePartId?: string;
    /**
     * 
     */
    severity?: ActiveAlertResponseSeverityEnum;
    /**
     * 
     */
    message?: string;
    /**
     * 
     */
    triggeredAt?: Date;
    /**
     * 
     */
    acknowledgedAt?: Date;
    /**
     * 
     */
    resolvedAt?: Date;
    /**
     * 
     */
    recommendedAction?: string;
}


/**
 * @export
 */
export const ActiveAlertResponseSeverityEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
} as const;
export type ActiveAlertResponseSeverityEnum = typeof ActiveAlertResponseSeverityEnum[keyof typeof ActiveAlertResponseSeverityEnum];


/**
 * Check if a given object implements the ActiveAlertResponse interface.
 */
export function instanceOfActiveAlertResponse(value: object): value is ActiveAlertResponse {
    return true;
}

export function ActiveAlertResponseFromJSON(json: any): ActiveAlertResponse {
    return ActiveAlertResponseFromJSONTyped(json, false);
}

export function ActiveAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveAlertResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'message': json['message'] == null ? undefined : json['message'],
        'triggeredAt': json['triggeredAt'] == null ? undefined : (parseDateTime(json['triggeredAt'])),
        'acknowledgedAt': json['acknowledgedAt'] == null ? undefined : (parseDateTime(json['acknowledgedAt'])),
        'resolvedAt': json['resolvedAt'] == null ? undefined : (parseDateTime(json['resolvedAt'])),
        'recommendedAction': json['recommendedAction'] == null ? undefined : json['recommendedAction'],
    };
}

export function ActiveAlertResponseToJSON(json: any): ActiveAlertResponse {
    return ActiveAlertResponseToJSONTyped(json, false);
}

export function ActiveAlertResponseToJSONTyped(value?: ActiveAlertResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ruleId': value['ruleId'],
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'severity': value['severity'],
        'message': value['message'],
        'triggeredAt': value['triggeredAt'] == null ? value['triggeredAt'] : serializeDateTime(value['triggeredAt']),
        'acknowledgedAt': value['acknowledgedAt'] == null ? value['acknowledgedAt'] : serializeDateTime(value['acknowledgedAt']),
        'resolvedAt': value['resolvedAt'] == null ? value['resolvedAt'] : serializeDateTime(value['resolvedAt']),
        'recommendedAction': value['recommendedAction'],
    };
}

